// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `th {
  justify-items: center;
}
th .mat-sort-header-content {
  margin-left: 10%;
}

td {
  text-align: center;
}

.table-responsive {
  overflow-x: auto;
}

.users-table {
  min-width: 1100px;
}

.green {
  color: #28a745;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/users-list/users-list.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;AACE;EACE,gBAAA;AACJ;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,cAAA;AAAF","sourcesContent":["th {\n  justify-items: center;\n\n  .mat-sort-header-content {\n    margin-left: 10%;\n  }\n}\n\ntd {\n  text-align: center;\n}\n\n.table-responsive {\n  overflow-x: auto;\n}\n\n.users-table {\n  min-width: 1100px;\n}\n\n.green {\n  color: #28a745;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
